export default __webpack_public_path__ + "static/media/Dinosaurs_08.47a2addd.png";